module.exports = __webpack_public_path__ + "static/contentP-7751d723be77f3a69762acf8e012aa78.png";